module.exports = __webpack_public_path__ + "img/nav-designer@2x.730e7a2.webp";